namespace _Ext.DevTools {
    export interface SergenConnection {
        Key?: string;
    }
}
